import {handleActions} from 'redux-actions';
import {BrotherMember} from '../constants/models';

const  BrothersMemberReducers = handleActions({
    SET_INDEX_BROTHERS_MEMBER: (state, {payload}) => (
        state.merge({
            index_data: payload
        })
    ),
    SET_SHOW_BROTHERS_MEMBER: (state, {payload}) => (
        state.merge({
            data: payload
        })
    ),
}, BrotherMember);

export default BrothersMemberReducers;


// WEBPACK FOOTER //
// ./src/dashboards_redux/reducers/BrothersMemberReducers.jsx